import React, { Component } from 'react';
import { CardButton } from './CardButton';

export class AdvancedBox extends Component {

  render() {

    return (
      <div className="CardBox">
        <div className="CardBoxShadow">
        </div>
        <div className="CardBoxTitleOuter">
          <p className="CardBoxTitle">
            Advanced
          </p>
					<p className="CardBoxTitle CardBoxSubtitle">
            Other fun whozits and whatzits!
          </p>
        </div>
        <div className="CardBoxContainer">

					<div className="CardBoxBackground AdvancedBoxBackground" />
					<div className="CardBoxTint" />

          {/*<CardButton rarity="legendary" titleBackground="legendaryTitle" cardTitle={ "ladder meta" } cardBackground="zap"/>
          <CardButton rarity="legendary" titleBackground="legendaryTitle" cardTitle={ "tourney meta" } cardBackground="poison"/>
          <CardButton rarity="legendary" titleBackground="legendaryTitle" cardTitle={ "F2P friendly" } cardBackground="mortar"/>





          <div className="CardButtonPusher" />
          <CardButton rarity="legendary" titleBackground="legendaryTitle longTitle9" cardTitle={ "ladder strong" } cardBackground="rage"/>
          <CardButton rarity="legendary" titleBackground="legendaryTitle longTitle9" cardTitle={ "tourney strong" } cardBackground="lightning"/>
          <div className="CardButtonPusher" />

          <CardButton rarity="legendary" titleBackground="legendaryTitle" cardTitle={ "anti-meta" } cardBackground="freeze"/>
          <CardButton rarity="legendary" titleBackground="legendaryTitle" cardTitle={ "off-meta" } cardBackground="heal"/>
          <CardButton rarity="legendary" titleBackground="legendaryTitle" cardTitle={ "randomizer" } cardBackground="graveyard"/>*/}




					<CardButton rarity="legendary2"
											titleBackground="legendary2Title"
											cardTitle={ "Coming soon! high use rate" }
											cardBackground="zap"
											archetypeName="highUseRate"/>
					<CardButton rarity="legendary2"
											titleBackground="legendary2Title longTitle9"
											cardTitle={ "Coming soon! high win rate" }
											cardBackground="freeze"
											archetypeName="highWinRate"/>
					<CardButton rarity="legendary2"
											titleBackground="legendary2Title"
											cardTitle={ "F2P friendly" }
											cardBackground="giant-snowball"
											archetypeName="F2PFriendly"/>


					<div className="CardButtonPusher" />
					<CardButton rarity="legendary2"
											titleBackground="legendary2Title"
											cardTitle={ "Coming soon! anti-meta" }
											cardBackground="tornado"
											archetypeName="antiMeta"/>
          <CardButton rarity="legendary2"
											titleBackground="legendary2Title"
											cardTitle={ "Coming soon! off-meta" }
											cardBackground="rage"
											archetypeName="offMeta"/>
					<div className="CardButtonPusher" />


					<CardButton rarity="legendary2"
											titleBackground="legendary2Title"
											cardTitle={ "randomizer" }
											cardBackground="graveyard"
											archetypeName="randomizer"/>



        </div>

      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Components/AdvancedBox.js